export default __webpack_public_path__ + "static/media/robin.9bf5d9b9.jpg";